export default class RepositoriesStore {
  constructor() {
    this.state = {};

    this.state.selectedTags = [];
  }
}



// WEBPACK FOOTER //
// ./modules/repositories/store.js